module.exports = __webpack_public_path__ + "static/media/MaisNaTela.98859e9f.png";